<template>
  <div class="progress-bar-container">
    <div
      class="progress-bar"
      :style="{ width: `${negativePercentage}%`, backgroundColor: negativeColor }"
      v-if="negativePercentage > 0"
    ></div>
    <div
      class="progress-bar"
      :style="{ width: `${neutralPercentage}%`, backgroundColor: neutralColor }"
      v-if="neutralPercentage > 0"
    ></div>
    <div
      class="progress-bar"
      :style="{ width: `${positivePercentage}%`, backgroundColor: positiveColor }"
      v-if="positivePercentage > 0"
    ></div>
  </div>
</template>

<script>
export default {
  name: 'ReviewProgressBar',
  props: {
    reviews: {
      type: Array,
      required: true,
      validator: (value) => value.every((num) => num >= 1 && num <= 5),
    },
  },
  computed: {
    negativeColor() {
      return '#F25362'
    },
    neutralColor() {
      return '#FFC700'
    },
    positiveColor() {
      return '#0B8C0B'
    },
    reviewCounts() {
      return this.reviews.reduce(
        (counts, review) => {
          if (review >= 1 && review <= 2) counts.negative++
          else if (review === 3) counts.neutral++
          else if (review >= 4 && review <= 5) counts.positive++
          return counts
        },
        { negative: 0, neutral: 0, positive: 0 },
      )
    },
    totalReviews() {
      return this.reviews.length
    },
    negativePercentage() {
      return (this.reviewCounts.negative / this.totalReviews) * 100
    },
    neutralPercentage() {
      return (this.reviewCounts.neutral / this.totalReviews) * 100
    },
    positivePercentage() {
      return (this.reviewCounts.positive / this.totalReviews) * 100
    },
  },
}
</script>

<style scoped>
.progress-bar-container {
  display: flex;
  height: 10px;
  width: 250px;
  background-color: #e0e0e0;
  border-radius: 10px;
  overflow: hidden;
}
.progress-bar {
  height: 100%;
}
</style>
